import { i18nKeys } from 'translationTypes'
import i18n from '../../../i18n'

export default {
  progressionCheckTitle: () => i18n.t(i18nKeys.progression_check__title),
  progressionCheckAccountCreatedTitle: () =>
    i18n.t(i18nKeys.progression_check__account_created_title),
  progressionCheckVerifyIdentityTitle: () =>
    i18n.t(i18nKeys.progression_check__verify_account_title),
  progressionCheckVerifyIdentityInProgressTitle: () =>
    i18n.t(i18nKeys.progression_check__verify_account_title_in_progress),
  progressionCheckVerifyIdentityUnderReview: () =>
    i18n.t(i18nKeys.progression_check__verify_account_under_review_status),
  progressionCheckVerifyIdentityUnableToVerify: () =>
    i18n.t(i18nKeys.progression_check__verify_account_unable_to_verify_status),
  progressionCheckVerifyIdentityDescription: () =>
    i18n.t(i18nKeys.progression_check__verify_account_description),
  progressionCheckVerifyIdentityUnderReviewDescription: () =>
    i18n.t(i18nKeys.progression_check__verify_account_under_review_description),
  progressionCheckVerifyIdentityUnableToVerifyDescription: () =>
    i18n.t(
      i18nKeys.progression_check__verify_account_unable_to_verify_description
    ),
  progressionCheckVerifyIdentityUnableToVerifyFAQDescription: () =>
    i18n.t(
      i18nKeys.progression_check__verify_account_unable_to_verify_faq_description
    ),
  progressionCheckVerifyIdentityButtonText: () =>
    i18n.t(i18nKeys.progression_check__verify_account_button_text),
  progressionCheckVerifyIdentityInProgressButtonText: () =>
    i18n.t(i18nKeys.progression_check__verify_account_button_text_in_progress),
  progressionCheckVerifyIdentityFAQButtonText: () =>
    i18n.t(i18nKeys.common__faq),
  progressionCheckIdentityVerifiedTitle: () =>
    i18n.t(i18nKeys.progression_check__account_verified_title),
  progressionCheckScheduleOrientationTitle: () =>
    i18n.t(i18nKeys.progression_check__schedule_orientation_title),
  scheduleOrientationDetails__reschedule: () =>
    i18n.t(i18nKeys.scheduleOrientationDetails__reschedule),
  progressionCheckScheduleOrientationDescription: () =>
    i18n.t(i18nKeys.progression_check__schedule_orientation_description),
  progressionCheckScheduleOrientationButtonText: () =>
    i18n.t(i18nKeys.progression_check__schedule_orientation_button_text),
  progressionCheckOrientationScheduledTitle: () =>
    i18n.t(i18nKeys.progression_check__orientation_scheduled_title),
  progressionCheckConfirmActivationTitle: () =>
    i18n.t(i18nKeys.progression_check__confirm_activation_title),
  progressionCheckConfirmActivationDescription: () =>
    i18n.t(i18nKeys.progression_check__confirm_activation_description),
  progressionCheckConfirmActivationDescriptionWithoutOrientation: () =>
    i18n.t(
      i18nKeys.progression_check__confirm_activation_description_without_orientation
    ),
  progressionActivationConfirmedTitle: () =>
    i18n.t(i18nKeys.progression_check__activation_confirmed_title),
  progressionCheckCompleteFirstDeliveryTitle: () =>
    i18n.t(i18nKeys.progression_check__complete_first_delivery_title),
  progressionCheckCompleteFirstDeliveryTitleDone: () =>
    i18n.t(i18nKeys.progression_check__complete_first_delivery_title_done),
  progressionCheckCompleteFirstDeliveryAppDescription: () =>
    i18n.t(i18nKeys.progression_check__complete_first_delivery_app_description),
  progressionCheckCompleteFirstDeliveryMobileWebDescription: () =>
    i18n.t(
      i18nKeys.progression_check__complete_first_delivery_mobile_web_description
    ),
  progressionCheckCompleteFirstDeliveryDownloadApp: () =>
    i18n.t(i18nKeys.common__downloadTheApp),
  progressionCheckCompleteFirstDeliveryGetStarted: () =>
    i18n.t(i18nKeys.progression_check__complete_first_delivery_app_button_text),
}
